import {
  AppDispatch,
  getOrganization,
  getOrganizationRequest } from
"@src/redux";
import { Col, Form, FormInstance, Input, Row, Select } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

type Props = {
  form: FormInstance;
};

const LevelAttribute = (props: Props) => {
  const { form } = props;
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { result: org } = useSelector(getOrganization);

  useEffect(() => {
    dispatch(getOrganizationRequest({ filter: { id: id } }));
  }, [id]);

  return org?.level?.childLevelList &&
  org?.level?.childLevelList?.length > 0 ?
  <Row gutter={10}>
      {org?.level?.childLevelList?.[0]?.levelAttributeList?.map(
      (list, index: number) => {
        let options =
        list?.optionList?.map((option) => {
          return {
            label: option,
            value: option
          };
        }) || [];

        form.setFieldValue(
          ["levelAttributeValueList", index, "levelAttributeId"],
          list.id
        );
        return (
          <Col
            span={
            org?.level?.childLevelList &&
            org?.level?.childLevelList?.length > 0 ?
            12 :
            24}>

            
              <Form.Item
              name={["levelAttributeValueList", index, "id"]}
              // initialValue={list?.id}
              hidden />
            
              <Form.Item
              name={[
              "levelAttributeValueList",
              index,
              "levelAttributeId"]}

              initialValue={`${list?.id}`}
              hidden>
              
                <Input value={list?.id} defaultValue={list?.id} />
              </Form.Item>

              <Form.Item
              name={["levelAttributeValueList", index, "value"]}
              label={list.name}
              rules={[
              {
                required: list.isMandatory,
                message: `${list.name} is required.`
              }]}>

              
                <Select options={options} />
              </Form.Item>
            </Col>);

      }
    )}
    </Row> :

  "";

};

export default LevelAttribute;